import { render, staticRenderFns } from "./EmptyListMessage.vue?vue&type=template&id=756ffc0c"
import script from "./EmptyListMessage.vue?vue&type=script&lang=js"
export * from "./EmptyListMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports